import { render, staticRenderFns } from "./ServiceTypeDataViewSidebar.vue?vue&type=template&id=c0bd8d64&scoped=true&"
import script from "./ServiceTypeDataViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeDataViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTypeDataViewSidebar.vue?vue&type=style&index=0&id=c0bd8d64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bd8d64",
  null
  
)

export default component.exports